import styled from 'styled-components';

export const TableHeaderCell = styled.th`
  background-color: ${({ theme: { colors } }) => colors['white-2']};
  color: ${({ theme: { colors } }) => colors['grey-14']};
  font-weight: normal;
  padding: 0 !important;
  vertical-align: top;
  border: 0;
  text-align: center;
`;

export const TableHeaderCellDiv = styled.div`
  padding: 8px;
  width: 100%;
  height: 100%;
  color: ${({ theme: { colors } }) => colors['black']};
  font-weight: 500;
  font-size: 14px;
`;

export const TableHeaderRowElement = styled.tr``;

export const StickyThead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
`;
